'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';
import { referenceProducts } from '../../collection-showcase/scenes/reference-products.jsx';
import { ShowcaseSpinner } from '../../collection-showcase/scenes/playback-controls.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { AppSourceBadge } from './app-window';
import { BusinessIcon } from './business-primitives';
import { me } from './business-facts';
export function AppUpdate({ applying: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'pop enter origin-top-right rounded-xl'}>
      <div className={'space-y-1 px-3 pt-3 pb-2'}>
        <p className={'text-ink-3 text-[12px]'}>
          {translateShowcaseNode(showcaseCopy, 'Review from Oct 7')}
        </p>
        <p className={'text-ink text-[14px] font-medium'}>
          {translateShowcaseNode(
            showcaseCopy,
            'Flag deposits before they fall overdue'
          )}
        </p>
        <p className={'text-ink-3 text-[12px] leading-4'}>
          {translateShowcaseNode(
            showcaseCopy,
            'Two deposits went overdue this week without anything in the board saying they were close.'
          )}
        </p>
      </div>
      <ul
        className={
          'border-y border-[color-mix(in_oklch,var(--border)_35%,transparent)]'
        }
      >
        <li className={'space-y-1 px-3 py-2'}>
          <div className={'flex items-start gap-2'}>
            <p className={'text-ink min-w-0 flex-1 text-[14px]'}>
              {translateShowcaseNode(
                showcaseCopy,
                'Show the due date on every open deposit'
              )}
            </p>
            <span
              className={
                'text-ink-2 rounded-md bg-[var(--secondary)] px-2 py-0.5 text-[12px]'
              }
            >
              {translateShowcaseNode(showcaseCopy, 'Small')}
            </span>
          </div>
          <p className={'text-ink-3 text-[12px] leading-4'}>
            {translateShowcaseNode(
              showcaseCopy,
              'Replace \u201CDeposit due\u201D with its date, so the next one to chase is obvious.'
            )}
          </p>
        </li>
      </ul>
      <div className={'flex items-center justify-between gap-2 p-2'}>
        <span
          className={
            'text-ink inline-flex h-7 items-center gap-1.5 rounded-md bg-[var(--background)] px-2.5 text-[12px] font-medium whitespace-nowrap shadow-[inset_0_0_0_1px_var(--border),0_1px_2px_rgb(0_0_0/0.05)]'
          }
        >
          {translateShowcaseNode(showcaseCopy, 'Dismiss')}
        </span>
        <span className={'flex items-center gap-2'}>
          <span
            className={
              'text-ink hidden h-7 items-center gap-1.5 rounded-md bg-[var(--background)] px-2.5 text-[12px] font-medium whitespace-nowrap shadow-[inset_0_0_0_1px_var(--border),0_1px_2px_rgb(0_0_0/0.05)] sm:inline-flex'
            }
          >
            {translateShowcaseNode(showcaseCopy, 'Discuss in chat')}
          </span>
          <span
            className={
              'inline-flex h-7 items-center gap-1.5 rounded-md bg-[var(--primary)] px-2.5 text-[12px] font-medium whitespace-nowrap text-[var(--primary-foreground)] transition-transform duration-150'
            }
            style={{
              transform: e ? 'scale(0.96)' : 'none',
            }}
          >
            {translateShowcaseNode(
              showcaseCopy,
              e ? <ShowcaseSpinner className={'size-3'} /> : null
            )}
            {translateShowcaseNode(showcaseCopy, 'Apply')}
          </span>
        </span>
      </div>
    </div>
  );
}
export const xr = ['Requested', 'In sampling', 'Received', 'Fit review'];
export const Sr = [
  'Pattern 1',
  'Knit swatch',
  'Pattern 1',
  'Knit swatch',
  'Fix shoulder and neck',
  'Pattern 1',
];
export const Cr = [1, 2, 1, 2, 0, 1];
export function AppTitle({ title: e, line: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'flex items-start justify-between gap-4'}>
      <div>
        <p
          className={
            'text-ink text-[20px] leading-7 font-semibold tracking-[-0.01em]'
          }
        >
          {translateShowcaseNode(showcaseCopy, e)}
        </p>
        <p className={'text-ink-3 mt-0.5 text-[13px]'}>
          {translateShowcaseNode(showcaseCopy, t)}
        </p>
      </div>
      <div className={'flex flex-col items-end gap-2'}>
        <AppSourceBadge kind={'illustrative'} />
        <span
          className={'text-ink-3 flex h-7 items-center gap-1.5 text-[12px]'}
        >
          <BusinessIcon name={'refresh'} className={'size-3.5'} />
          {translateShowcaseNode(showcaseCopy, 'Refreshes daily at 8:00')}
        </span>
      </div>
    </div>
  );
}
export function SampleTracker({ onInteract: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let [t, n] = React.useState(Cr),
    [r, i] = React.useState(null);
  return (
    <div className={'h-full overflow-hidden px-4 pt-4 pb-24 md:px-6 md:pt-5'}>
      <AppTitle
        title={translateShowcaseNode(showcaseCopy, 'LISI\xC8RE samples')}
        line={'FW27 sample rounds, request to fit review'}
      />
      <div className={'mt-4 grid grid-cols-2 gap-2 lg:grid-cols-4'}>
        {translateShowcaseNode(
          showcaseCopy,
          xr.map((a, o) => (
            <div
              key={a}
              className={
                'enter flex min-h-[150px] flex-col gap-1.5 rounded-[10px] bg-[var(--tint)] p-1.5 lg:min-h-[300px]'
              }
              style={{
                '--i': String(o),
              }}
            >
              <p
                className={
                  'text-ink-2 flex items-center justify-between px-1.5 pt-1 text-[12.5px] font-medium'
                }
              >
                {translateShowcaseNode(showcaseCopy, a)}
                <span className={'num text-ink-4 text-[12px]'}>
                  {translateShowcaseNode(
                    showcaseCopy,
                    t.filter((e) => e === o).length
                  )}
                </span>
              </p>
              {translateShowcaseNode(
                showcaseCopy,
                referenceProducts.map((a, s) =>
                  t[s] === o ? (
                    <button
                      key={`${a.style}-${o}`}
                      type={'button'}
                      disabled={o === xr.length - 1}
                      onClick={() => {
                        (e(),
                          n((e) =>
                            e.map((e, t) =>
                              t === s ? Math.min(e + 1, xr.length - 1) : e
                            )
                          ),
                          i(s));
                      }}
                      className={
                        'enter press flex min-h-10 flex-col gap-0.5 rounded-[8px] bg-[var(--background)] px-2.5 py-2 text-left shadow-[var(--sh-1)] disabled:active:scale-100'
                      }
                    >
                      <span
                        className={
                          'text-ink text-[12.5px] leading-snug font-medium'
                        }
                      >
                        {translateShowcaseNode(showcaseCopy, a.style)}
                      </span>
                      <span
                        className={
                          'text-ink-4 flex items-center justify-between text-[11.5px]'
                        }
                      >
                        {translateShowcaseNode(
                          showcaseCopy,
                          r === s ? 'Moved by you \xB7 now' : Sr[s]
                        )}
                        {translateShowcaseNode(
                          showcaseCopy,
                          o < xr.length - 1 ? (
                            <ShowcaseIcon
                              name={'arrowRight'}
                              className={'size-3'}
                            />
                          ) : null
                        )}
                      </span>
                    </button>
                  ) : null
                )
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
export const Er = [
  {
    key: 'orders',
    name: me.name,
    real: !1,
  },
  {
    key: 'planner',
    name: 'Halden SS27 Line Planner',
    real: !0,
  },
  {
    key: 'samples',
    name: 'LISI\xC8RE Samples',
    real: !1,
  },
];
export const Dr = me.request;
export const Or = 24;
export const R = {
  type: 300,
  send: 300 + Dr.length * Or + 250,
  build: 2700,
  built: 4700,
  brun: 5600,
  press: 6800,
  received: 7e3,
  stock: 8200,
  board: 10200,
  reviewButton: 10500,
  reviewOpen: 11e3,
  apply: 12300,
  applied: 12800,
  pin: 13700,
};
export const kr = 15e3;
export const Ar = ['planner', 'samples'];
export const jr = {
  data: 'filter',
  decide: 'edit',
  fresh: 'refresh',
  yours: 'pin',
};
